import { render, staticRenderFns } from "./FollowUpTodoView.vue?vue&type=template&id=6953d42b"
import script from "./FollowUpTodoView.vue?vue&type=script&lang=js"
export * from "./FollowUpTodoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports